var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"div-iframe"},[_c('iframe',{ref:"iframeModel",staticClass:"iframe-model",attrs:{"frameborder":"0","src":"/feishGPT/index.html"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }